module.exports = __webpack_public_path__ + "static/media/ClaimRequest.d2ce5eac.svg";